import * as React from "react";
import { useState, useEffect } from "react";
import i18n from "i18n";
import NumberFormat, { NumberFormatProps } from "react-number-format";
import { TextField } from "@material-ui/core";

const CustomInput = ({
  className,
  label,
  labelOnFocus,
  margin,
  value,
  onFocus,
  onBlur,
  ...props
}) => {
  const [currentLabel, setCurrentLabel] = useState(label);

  const handleFocusInput = (ev) => {
    ev.stopPropagation();
    if (!value && labelOnFocus) setCurrentLabel(labelOnFocus);
  };

  const handleBlurInput = (ev) => {
    if (currentLabel !== label) setCurrentLabel(label);
  };

  return (
    <TextField
      {...props}
      className={className}
      label={currentLabel}
      value={value}
      margin={margin as any}
      fullWidth
      onFocus={(ev) => {
        handleFocusInput(ev);
        onFocus(ev);
      }}
      onBlur={(ev) => {
        handleBlurInput(ev);
        onBlur(ev);
      }}
      InputLabelProps={{
        shrink: Boolean(value),
      }}
    />
  );
};

interface IProps extends NumberFormatProps {
  label: string;
  labelOnFocus?: string;
  value?: number;
  decimalPlaces?: number;
  fixedDecimalScale?: boolean;
  autoComplete?: string;
  margin?: string;
  onInputBlur?: (ev: any, value?: number) => void;
}

const NumberField = ({
  className,
  label,
  labelOnFocus,
  value,
  decimalPlaces = 2,
  fixedDecimalScale = true,
  autoComplete = "off",
  margin,
  onInputBlur = () => {},
  ...props
}: IProps) => {
  const [currentValue, setCurrentValue] = useState(value);

  let decimalSeparator = ",";
  let thousandSeparator = ".";

  if (i18n.language !== "PT") {
    decimalSeparator = ".";
    thousandSeparator = ",";
  }

  useEffect(() => {
    if (value !== currentValue) {
      setCurrentValue(value);
    }
  }, [value]);

  const handleBlurInput = (ev) => {
    const value = toNumber(ev.target.value);
    onInputBlur(ev, value);
  };

  return (
    <NumberFormat
      {...props}
      decimalScale={decimalPlaces}
      fixedDecimalScale={true}
      autoComplete={"off"}
      decimalSeparator={decimalSeparator}
      thousandSeparator={thousandSeparator}
      defaultValue={currentValue}
      onBlur={handleBlurInput}
      customInput={(inputProps) => (
        <CustomInput
          {...inputProps}
          className={className}
          label={label}
          labelOnFocus={labelOnFocus}
          margin={margin}
        />
      )}
    />
  );
};

function toNumber(value?: string): number | undefined {
  if (!value) return undefined;

  if (i18n.language === "PT") value = value.replace(".", "").replace(",", ".");
  else value = value.replace(",", "");

  let numValue = Number(value);
  return numValue ? numValue : undefined;
}

export default NumberField;



// WEBPACK FOOTER //
// ./src/common/components/fields/NumberField.tsx